"use strict";

var _global = require("global");

if (_global.window) {
  _global.window.STORYBOOK_ENV = 'react';
}